module.exports = __webpack_public_path__ + "img/complexity.30606fd5.svg";